<template>
    <ContainerLayout page="0" :loading="loading">
        <template v-slot:navbar>
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link to="/profile/company" class="nav-link">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </template>
        <div v-if="loaded_data" class="content px-1">
            <div class="w-100 row pt-0 mx-0">
                <div v-for="(item, index) in users" :key="index"
                    class="col-lg-4 col-md-6 col-sm-12 col-12 mb-4 px-0 px-md-2">
                    <div class="h-100 card-container"
                        style="word-break: break-all; overflow-wrap: break-word; text-overflow: ellipsis;">
                        <div class="h-100 w-100 card d-flex flex-column justify-content-center"
                            style="border-radius: 0.25rem; border: 1.5px solid rgba(0,0,0,.125); box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);">
                            <div class="m-3">
                                <div class="d-flex align-items-center">
                                    <img v-if="item.image_url" :src="item.image_url" alt="user" class="rounded-circle"
                                        style="width: 3rem; height: 3rem; object-fit: cover; object-position: center;">
                                    <font-awesome-icon v-else icon="user-circle" class="rounded-circle"
                                        style="width: 3rem; height: 3rem;" />
                                    <div class="d-flex ml-2"
                                        style="flex-direction: column; float: left; margin-right: 0.8rem; font-size: 13px !important;">
                                        <small>{{ item.name }}</small>
                                        <small class="text-muted" style="font-weight: 500;">{{ item.email }}</small>
                                        <small v-if="item.company_position || item.company_department">
                                            {{ item.company_position }} <span
                                                v-if="item.company_position && item.company_department">-</span> {{
                                                    item.company_department }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="content px-1">
            <div class="w-100 row pt-0 mx-0">
                <div v-for="(item, index) in [1, 2, 3]" :key="index"
                    class="col-lg-4 col-md-6 col-sm-12 col-12 mb-4 px-0 px-md-2">
                    <div class="skeleton-card" />
                </div>
            </div>
        </div>
    </ContainerLayout>
</template>
  
<script>
import ContainerLayout from "../../ContainerLayout.vue";
import CompanyService from "@/services/company.service";

export default {
    name: "TransactionIndex",
    components: {
        ContainerLayout,
    },
    data() {
        return {
            loaded_data: false,
            loading: false,
            users: [],
        };
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
        currentCompany() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user.company : null;
        },
    },
    created() {
        if (this.currentCompany) {
            this.loading = true;
            let loader = this.$loading.show();

            CompanyService.get(this.currentCompany.id)
                .then((response) => {
                    this.loading = false;
                    loader.hide();
                    this.loaded_data = true;

                    this.users = response.data.data.users;
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();
                    this.loaded_data = true;
                    console.log(error);
                });
        }
    },
    methods: {

    },
};
</script>

<style scoped>
.skeleton-card {
    width: 100%;
    height: 85px;
    background-color: #e6e6e6;
    border-radius: 5px;
}
</style>